<section class="divider">
	<h2 class="secondary-header !mb-0">
		{{ sectionTitle() }}
	</h2>

	<uc-description [description]="description()" />

	<!-- DESKTOP -->
	<div class="hidden grid-cols-4 gap-8 mt-6 md:grid">
		@for (link of links(); track $index) {
			<a [routerLink]="link.link">
				<span
					class="block font-bold font-base hover:text-uc-blue-900 hover:transition-colors"
					>{{ link.name }}</span
				>

				@if (link.link.includes('clearing') && !clearingEnabled) {
					<span class="block text-sm text-gray-500">{{ clearingCopy }}</span>
				} @else {
					<span class="block text-sm text-gray-500"
						>{{ link.courses_count | number }} courses found</span
					>
				}
			</a>
		}
	</div>

	<!-- MOBILE -->
	<div class="mt-6 !-mx-5 sm:!mx-0 md:hidden">
		<swiper-container #swiperRef init="false">
			@for (tiles of groupedLinks(); track $index) {
				<swiper-slide class="block h-auto px-5">
					<div class="grid h-full space-y-8">
						@for (tile of tiles; track $index; let last = $last) {
							<a [routerLink]="tile.link">
								<span
									class="block font-bold font-base hover:text-uc-blue-900 hover:transition-colors"
									>{{ tile.name }} Courses</span
								>
								@if (tile.link.includes('clearing') && !clearingEnabled) {
									<span class="block text-sm text-gray-500">{{
										clearingCopy
									}}</span>
								} @else {
									<span class="block text-sm text-gray-500"
										>{{ tile.courses_count }} courses found</span
									>
								}
							</a>
						}
					</div>
				</swiper-slide>
			}
		</swiper-container>
	</div>
</section>
